import Skeleton from '@passkeys/ui/skeleton';
import TokenIcon from '@passkeys/ui/token-icon';

import type { Asset } from '@/types';

export interface HeroProps {
  asset?: Asset;
}

function Hero({ asset }: HeroProps) {
  return (
    <div className="flex flex-col items-center">
      {asset ? (
        <TokenIcon
          name={asset.name}
          displayName={asset.displayName}
          size={80}
        />
      ) : (
        <Skeleton height={80} width={80} />
      )}
    </div>
  );
}

export default Hero;
